import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { UrlService } from 'src/environments/urlService';
import { FSFundMetricsMiniDTO, FundStrategyModel, GroupFS, SubGroupFS } from '../pojo/fund-strategy-export-classes';

@Injectable({
  providedIn: 'root',
})

export class FSModelBackendService {
  private readonly url;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'fund-strategy';
  }

  getModelByUUID(fsUUID: string): Observable<FundStrategyModel> {
    return this.http.get<FundStrategyModel>(
      `${this.url}/${fsUUID}`,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      }
    );
  }

  getAllByOrg(orgUUID: string): Promise<FundStrategyModel[]> {
    return this.http.get<FundStrategyModel[]>(
      `${this.url}/all/${orgUUID}`,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json',
      }
    ).toPromise();
  }

  saveNewModel(model: FundStrategyModel): Observable<FundStrategyModel> {
    return this.http.post<FundStrategyModel>(this.url, model, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  saveMetrics(fsUUID: string, metricsData: FSFundMetricsMiniDTO): Observable<void> {
    const url = `${this.url}/${fsUUID}/metrics`;
    return this.http.patch<void>(url, metricsData, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  updateSubGroupOrder(sbUUID: string, newSbOrder: number): Observable<FundStrategyModel> {
    const url = `${this.url}/${sbUUID}/sub-groups-order`;
    return this.http.patch<FundStrategyModel>(url, newSbOrder, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  updateGroupOrder(grUUID: string, newGroupOrder: number): Observable<FundStrategyModel> {
    const url = `${this.url}/${grUUID}/groups-order`;
    return this.http.patch<FundStrategyModel>(url, newGroupOrder, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  deleteModel(fsUUID: string): Promise<object | undefined> {
    return this.http.delete(this.url + '/' + fsUUID, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    }).toPromise();
  }

  addGroupToModel(fsUUID: string, groupDTO: GroupFS): Observable<FundStrategyModel> {
    const url = `${this.url}/${fsUUID}/group`;
    return this.http.post<FundStrategyModel>(url, groupDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  renameModel(fsUUID: string, newName: string): Observable<FundStrategyModel> {
    const url = `${this.url}/${fsUUID}/rename`;
    return this.http.patch<FundStrategyModel>(url, newName, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  updateGroupName(grUUID: string, newName: string): Observable<FundStrategyModel> {
    const url = `${this.url}/group/${grUUID}/name`;
    return this.http.patch<FundStrategyModel>(url, newName, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  updateSubGroupName(sbUUID: string, newName: string): Observable<FundStrategyModel> {
    const url = `${this.url}/sub-group/${sbUUID}/name`;
    return this.http.patch<FundStrategyModel>(url, newName, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  duplicateGroup(grUUID: string): Observable<FundStrategyModel> {
    const url = `${this.url}/group/${grUUID}/duplicate`;
    return this.http.post<FundStrategyModel>(url, null, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  addSubGroup(grUUID: string, subGroupDTO: SubGroupFS): Observable<FundStrategyModel> {
    const url = `${this.url}/group/${grUUID}/sub-group`;
    return this.http.post<FundStrategyModel>(url, subGroupDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  updateSubGroup(subGroupDTO: SubGroupFS): Observable<FundStrategyModel> {
    const url = `${this.url}/sub-group`;
    return this.http.put<FundStrategyModel>(url, subGroupDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


  duplicateSubGroup(sbUUID: string): Observable<FundStrategyModel> {
    const url = `${this.url}/sub-group/${sbUUID}/duplicate`;
    return this.http.post<FundStrategyModel>(url, null, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  deleteFundStrategyGroup(grUUID: string): Promise<object | undefined> {
    const url = `${this.url}/group/${grUUID}`;

    return this.http.delete(url, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    }).toPromise();
  }

  deleteFundStrategySubGroup(sbUUID: string): Observable<FundStrategyModel> {
    const url = `${this.url}/sub-group/${sbUUID}`;
    return this.http.delete<FundStrategyModel>(url, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }


}
